<template>
    <div class="scroll-wrap">
        <slot></slot>
        <div class="scroll-inner-wrap">
            <div v-for="logo in logoUse" :key="logo.key">
                <img class="scroll-item" :class="{ svg: getExt(logo.src) === 'svg' }" :src="logo.src" :alt="logo.alt">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LogoScroller",
        props: {
            logos: {
                type: Array
            }
        },
        data () {
            return {
                data: [
                    { key: 'php', src: 'php-logo.png', alt: 'PHP logo' },
                    { key: 'cakephp', src: 'cakephp.logo.jpg', alt: 'CakePhp logo' },
                    { key: 'php_unit', src: 'PhpUnit-logo.png', alt: 'PHP Unit logo' },
                    { key: 'js', src: 'js-logo.png', alt: 'Javascript logo' },
                    { key: 'html5', src: 'HTML5-logo.png', alt: 'HTML5 logo' },
                    { key: 'css3', src: 'css3-logo.png', alt: 'CSS3 logo' },
                    { key: 'sass', src: 'sass-logo.svg', alt: 'SASS logo' },
                    { key: 'vue', src: 'vue-logo.png', alt: 'Vue logo' },
                    { key: 'jest', src: 'jest-logo.png', alt: 'Jest JS logo' },
                    { key: 'aws', src: 'aws.png', alt: 'AWS logo' },
                    { key: 'docker', src: 'docker.png', alt: 'Docker logo' },
                    { key: 'git_hub', src: 'GitHub_Logo.png', alt: 'Github logo' },
                    { key: 'bit_bucket', src: 'Bitbucket-logo.png', alt: 'Bitbucket logo' },
                    { key: 'git', src: 'git-logo.png', alt: 'Git logo' },
                    { key: 'npm', src: 'npm-logo.png', alt: 'NPM logo' },
                    { key: 'webpack', src: 'webpack-logo.png', alt: 'Webpack logo' },
                    { key: 'google_ads', src: 'google-ads-logo.svg', alt: 'Google Ads Api logo' },
                    { key: 'stripe', src: 'stripe-logo.png', alt: 'Strip Api logo' },
                    { key: 'twilio', src: 'twilio-logo.svg', alt: 'Twilio Api logo' },
                    { key: 'python', src: 'python-logo.png', alt: 'Python logo' },
                    { key: 'node', src: 'nodejs-logo.png', alt: 'Node Js logo' },
                    { key: 'express', src: 'expressjs-logo.png', alt: 'Express Js logo' },
                    { key: 'typescript', src: 'ts-logo.png', alt: 'Typescript logo' },
                    { key: 'sagemaker', src: 'sagemaker-logo.png', alt: 'Sagemaker logo' },
                    { key: 'scikitlearn', src: 'scikitlearn-logo.png', alt: 'Scikitleanr logo' },
                    { key: 'numpy', src: 'numpy-logo.png', alt: 'NumPy logo' },
                    { key: 'pandas', src: 'Pandas_logo.png', alt: 'Pandas' },
                    { key: 'jquery', src: 'JQuery_logo.png', alt: 'JQuery logo' },
                    { key: 'mysql', src: 'MySQL-logo.png', alt: 'MySQL logo' },
                    { key: 'R', src: 'Rlogo.png', alt: 'R language logo' },
                    { key: 'c++', src: 'C%2B%2B-logo.png', alt: 'C++ logo' },
                    { key: 'matplotlib', src: 'Matplotlib_logo.png', alt: 'Matplotlib logo' },
                ]
            }
        },
        computed: {
            logoSrcs () {
                return this.data.map(l => {
                    return {
                        ...l,
                        src: this.getImageUrl(l.src),
                    }
                })
            },
            logoUse () {
                return this.logos.map(key => {
                    return this.logoSrcs.find(l => l.key === key)
                }).filter(l => l)
            }
        },
        methods: {
            getExt (file) {
                let match = file.match(/\.([^.]+)$/)
                return match ? match[1] : null
            }
        }
    }
</script>

<style scoped lang="scss">
    .scroll-wrap {
        .scroll-inner-wrap {
            display: flex;
            align-items: center;
            padding-bottom: 10px;
            flex-wrap: wrap;
            .scroll-item {
                max-width: 70px;
                max-height: 50px;
                padding: 5px;

                &.svg {
                    min-width: 50px;
                }
            }
        }
    }
</style>